import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
// import { AngularFontAwesomeComponent } from 'angular-font-awesome';
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "../../app.component";

@Component({
  selector: "app-analytics-monthly-gauges",
  templateUrl: "./analytics-monthly-gauges.component.html",
  styleUrls: ["./analytics-monthly-gauges.component.scss"],
})
export class AnalyticsMonthlyGaugesComponent implements OnInit {
  public loading = false;
  gaugeType = "semi";
  public gaugeValue: number = -1;
  gaugeLabel = "Sent";
  gaugeAppendText = "";
  private BASE_URL = GlobalVariable;
  outlet_id: String;
  review_sent: number;
  review_click: number;
  review_percent: number;
  progress_style: any;
  toolTip: string;
  @Output() scrTo = new EventEmitter();
  private _analyticsData: any;

  @Input()
  set analyticsData(value) {
    this._analyticsData = value;
  }
  get analyticsData() {
    return this._analyticsData;
  }

  @ViewChild("reviewstats") reviewstats;
  scrollById() {
    this.scrTo.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.analyticsData &&
      changes.analyticsData.currentValue !== undefined
    ) {
      let analyticsData = changes.analyticsData.currentValue;
      this.analyticsData = analyticsData;
      this.getClickThroughRate();
    }
  }

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {
    this.getClickThroughRate();
  }

  getClickThroughRate() {
    this.review_sent = this.analyticsData["total_review_request"];
    this.review_click =
      this.analyticsData["total_review_request_clicked_count"];
    this.review_percent = Math.round(
      (this.review_click / this.review_sent) * 100
    );
    this.toolTip =
      this.review_click +
      " - (" +
      Math.round((this.review_click / this.review_sent) * 100) +
      "% Clicked)";

    this.gaugeValue = this.review_percent;

    this.progress_style = {
      "background-color": "#03c0c2",
      "border-radius": "20px",
      width: Math.round(this.review_percent) + "%",
    };
  }

  /**
   *Common toastr for success function
   *
   * @param {string} msg
   * @memberof AnalyticsInviteRateReviewsComponent
   */
  showSuccess(msg: string) {
    this.toastrService.success(msg);
  }

  /**
   * Common toastr for error function
   *
   * @param {string} msg
   * @memberof AnalyticsInviteRateReviewsComponent
   */
  showError(msg: string) {
    this.toastrService.error(msg);
  }
}
